// i18n keys (en/zh/ja) don't map 1:1 to BCP-47 tags; ja → ja-JP, zh → zh-CN
const BCP47_LOCALE_MAP: Record<string, string> = {
  ja: 'ja-JP',
  zh: 'zh-CN',
}

function toDate(value: Date | string) {
  return typeof value === 'string' ? new Date(value) : value
}

export function resolveBcp47Locale(i18nLanguage: string) {
  return BCP47_LOCALE_MAP[i18nLanguage] ?? i18nLanguage
}

/** Renew success toast and similar full dates (e.g. 21 Oct 2026). */
export function formatDateWithYear(value: Date | string, locale: string) {
  return toDate(value).toLocaleDateString(resolveBcp47Locale(locale), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

/** BRAVE file card tooltip created / last modified (24-hour clock). */
export function formatBraveTooltipDateTime(value: Date | string, locale: string) {
  return toDate(value).toLocaleString(resolveBcp47Locale(locale), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

/** Retention policy tooltip when deletion is more than 48 hours away (e.g. 22 Mar). */
export function formatDayAndMonth(value: Date | string, locale: string) {
  return toDate(value).toLocaleDateString(resolveBcp47Locale(locale), {
    day: 'numeric',
    month: 'short',
  })
}

/** Retention policy tooltip for today / tomorrow buckets. */
export function formatTime(value: Date | string, locale: string) {
  return toDate(value).toLocaleTimeString(resolveBcp47Locale(locale), {
    hour: 'numeric',
    minute: '2-digit',
  })
}
